import { render, staticRenderFns } from "./TipiAbbonamento.vue?vue&type=template&id=42873250&"
import script from "./TipiAbbonamento.vue?vue&type=script&lang=js&"
export * from "./TipiAbbonamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports